module.exports = __webpack_public_path__ + "img/lg.7085103d.png";